import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { OAuthEvent } from 'angular-oauth2-oidc';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CallbackComponent implements OnInit {
  private authService = inject(AuthService);
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);

  ngOnInit() {
    const isAuthenticated = this.authService.isAuthenticated();
    if (isAuthenticated) {
      this.router.navigate(['/']);
    } else {
      this.subscribeToAuthEvents();
    }
  }

  subscribeToAuthEvents(): void {
    this.authService.getAuthEventsStream()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((event: OAuthEvent) => {
      if (event.type === 'token_received') {
        this.router.navigate(['/']);
      } else if (event.type === 'code_error') {
        this.router.navigate(['/access-denied']);
      }
    });
  }
}
